/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Available notification preference types
 * @export
 */
export const NotificationPreferenceTypeEnum = {
    DeliveryEmail: 'DELIVERY_EMAIL',
    DeliverySms: 'DELIVERY_SMS',
    DeliveryInApp: 'DELIVERY_IN_APP',
    Language: 'LANGUAGE'
} as const;
export type NotificationPreferenceTypeEnum = typeof NotificationPreferenceTypeEnum[keyof typeof NotificationPreferenceTypeEnum];


export function instanceOfNotificationPreferenceTypeEnum(value: any): boolean {
    for (const key in NotificationPreferenceTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(NotificationPreferenceTypeEnum, key)) {
            if (NotificationPreferenceTypeEnum[key as keyof typeof NotificationPreferenceTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NotificationPreferenceTypeEnumFromJSON(json: any): NotificationPreferenceTypeEnum {
    return NotificationPreferenceTypeEnumFromJSONTyped(json, false);
}

export function NotificationPreferenceTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceTypeEnum {
    return json as NotificationPreferenceTypeEnum;
}

export function NotificationPreferenceTypeEnumToJSON(value?: NotificationPreferenceTypeEnum | null): any {
    return value as any;
}

export function NotificationPreferenceTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): NotificationPreferenceTypeEnum {
    return value as NotificationPreferenceTypeEnum;
}

